import { useMemo } from "react";
import { runtimeConfig } from "@src/runtime-config";
import { CLIENT_ID } from "@api/client-id";
import { SettingsApiClient } from "@stellar/settings-api-client";

type SettingsApiClientInstance = InstanceType<typeof SettingsApiClient>;
let client: SettingsApiClientInstance;

/** Initializes client to SettingsAPI if not already initialized and returns it */
export function useSettingsApiClient(): SettingsApiClientInstance {
  // Make sure the client is only created once
  const memoizedClient = useMemo(() => {
    client = new SettingsApiClient(runtimeConfig.urls.apiBaseUrl, {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "X-Holobuilder-Component": CLIENT_ID,
    });

    return client;
  }, []);

  return memoizedClient;
}
